import React from "react"
import styled from "@emotion/styled"
import { useQueryString } from "@capitaria/capitaria-utms"

import { trackEvent } from "../../helpers/tracker"

const Box = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  padding: 1rem 0;
  margin: 1rem 10px 2rem;
  width: 300px;
  min-height: 100px;
  cursor: pointer;
  text-decoration: none;
`
const BoxImportant = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.18);
  border-radius: 5px;
  padding: 1rem 0;
  margin: 1rem 10px 2rem;
  width: 300px;
  min-height: 143px;
  cursor: pointer;
  text-decoration: none;
`

const BoxContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
`

const ContainerTax = styled.div`
  font-size: 10px;
  line-height: 14px;
  color: #363f41;
  font-weight: bold;
`

type Props = {
  children: any
  event: string
  url: string
  tax?: string
  styleBox?: any
  styleBoxContent?: any
}

const PayBox = ({ children, event, url, tax, styleBox = {}, styleBoxContent = {} }: Props) => {
  const {
    parsedQueryString: { mc_origen: mcOrigen },
    queryString,
  } = useQueryString()

  const onClickPayBox = () =>
    trackEvent(`deposit:${event}`, { mc_origen: mcOrigen })

  return (
    <Box
      style={styleBox}
      href={`${url}${queryString}`}
      onClick={onClickPayBox}
      target="_blank"
      rel="noopener noreferrer"
    >
      <BoxContent style={styleBoxContent}>{children}</BoxContent>
      <ContainerTax>{tax}</ContainerTax>
    </Box>
  )
}

export default PayBox
